import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type RecordOrderPullsMutationVariables = Types.Exact<{
  input: Types.RecordOrderPullsInput;
}>;


export type RecordOrderPullsMutation = { __typename?: 'Mutation', recordOrderPulls: { __typename?: 'OrderPayload', order?: { __typename?: 'OrderStateData', orderId: string, orderNumber: string, status: Types.OrderStatus, shipFromSiteLocationId: string, customer: { __typename?: 'OrderCustomerData', id: string, name: string }, lineItems: Array<{ __typename?: 'LineItemData', id: string, lineNumber: number, itemId: string, sku: string, name: string, quantity?: number | null, orderedQuantity?: number | null }>, allocations: Array<{ __typename?: 'AllocationItemData', lineItemId: string, itemId: string, locationId?: string | null, grade: number, quantity: number }>, pulls: Array<{ __typename?: 'OrderLinePull', pullId: string, lineItemId: string, itemId: string, locationId: string, locationName?: string | null, grade: number, quantity: number, pulledBy: string, pulledAt: Types.TDateISO }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, warnings?: Array<{ __typename?: 'OverAllocationWarningData', itemId: string, locationId: string, grade: number, requestedQuantity: number, availableQuantity: number }> | null } };


export const RecordOrderPullsDocument = new TypedDocumentString(`
    mutation RecordOrderPulls($input: RecordOrderPullsInput!) {
  recordOrderPulls(input: $input) {
    order {
      ...PullOrderFields
    }
    errors {
      code
      message
    }
    warnings {
      itemId
      locationId
      grade
      requestedQuantity
      availableQuantity
    }
  }
}
    fragment PullOrderFields on OrderStateData {
  orderId
  orderNumber
  status
  shipFromSiteLocationId
  customer {
    id
    name
  }
  lineItems {
    id
    lineNumber
    itemId
    sku
    name
    quantity
    orderedQuantity
  }
  allocations {
    lineItemId
    itemId
    locationId
    grade
    quantity
  }
  pulls {
    pullId
    lineItemId
    itemId
    locationId
    locationName
    grade
    quantity
    pulledBy
    pulledAt
  }
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    RecordOrderPulls: build.mutation<RecordOrderPullsMutation, RecordOrderPullsMutationVariables>({
      query: (variables) => ({ document: RecordOrderPullsDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useRecordOrderPullsMutation } = injectedRtkApi;
